import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import StockCountLine from "../../../../utilities/data/model/StockCountLine";
import { of } from "@nozbe/watermelondb/utils/rx";
import { Colors, Spacings, TouchableOpacity, View } from "react-native-ui-lib";
import { Card, ProductThumbnail, Text } from "@towersystems/roam-common-native";
import { toTitleCase } from "@towersystems/roam-common/lib/shared-utils";
import { AntDesign } from "@expo/vector-icons";

const getObservables = ({
  stockCountLineItem,
}: {
  stockCountLineItem: StockCountLine;
}) => ({
  product: stockCountLineItem.product.id
    ? stockCountLineItem.product.observe()
    : of(null),
  counted: stockCountLineItem.counted,
});

export interface CountedItemSummaryCardProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  stockCountLineItem: StockCountLine;
  onPress?: () => void;
  compact?: boolean;
}

const CountedItemSummaryCardRenderer = ({
  product,
  stockCountLineItem,
  counted,
  onPress,
  compact,
}: CountedItemSummaryCardProps) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <Card filled={false}>
        <View
          flex
          row
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <View
            style={{ alignItems: "center", flexBasis: "100%", flexShrink: 1 }}
            row
          >
            <ProductThumbnail
              imageUrl={product?.imageUrl}
              hideQuantity
              isInternalProduct={false}
              size={compact ? "small" : "large"}
            />
            <View marginL-20 style={{ flexShrink: 1 }}>
              <Text variant="heading1" numberOfLines={1} ellipsizeMode="head">
                {toTitleCase(
                  product?.name || stockCountLineItem?.name || "Unknown Product"
                )}
              </Text>
              <Text>{product?.displayName}</Text>
              <Text color="subdued">
                {product?.stockNumber || stockCountLineItem.barcode || ""}
              </Text>
            </View>
          </View>
          <View style={{ marginLeft: Spacings.s4 }} row>
            <View>
              <Text variant="heading1">{counted}</Text>
            </View>
            <Text>
              <AntDesign
                style={[{ marginLeft: Spacings.s4, color: Colors.Text }]}
                name="right"
                size={24}
              />
            </Text>
          </View>
        </View>
      </Card>
    </TouchableOpacity>
  );
};

const enhance = withObservables(["stockCountLineItem"], getObservables);

const CountedItemSummaryCard = enhance(CountedItemSummaryCardRenderer);

export default CountedItemSummaryCard;
